import { Appointment } from "../../../api/appointment.types";
import { AppointmentsByMisTokenAction } from "./appointments.bymistoken.types";

export const appointmentsByMisTokenRequestAction = (params: { medic_user_id: number }): AppointmentsByMisTokenAction => ({ type: 'APPOINTMENTS_BY_MISTOKEN_REQUEST', params })

export const appointmentsByMisTokenSuccessAction = (appointments: Appointment[]): AppointmentsByMisTokenAction => ({ type: 'APPOINTMENTS_BY_MISTOKEN_SUCCESS', params: appointments })

export const appointmentsByMisTokenFailureAction = (error?: any): AppointmentsByMisTokenAction => ({ type: 'APPOINTMENTS_BY_MISTOKEN_FAILURE', params: error })